import {animate, style, transition, trigger} from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({
      opacity: 0,
    }),
    animate(
      '.3s cubic-bezier(.32,.9,.9,.96)',
      style({
        opacity: '1',
      }),
    ),
  ]),
  transition(':leave', [
    style({
      opacity: '1',
    }),
    animate(
      '.3s cubic-bezier(.32,.9,.9,.96)',
      style({
        opacity: 0,
      }),
    ),
  ]),
]);
